export const errorToast = 'error';
export const successToast = 'success';
export const warningToast = 'warning';
export const toastTimeoutMs = 5000;